import React from "react";
import useFetch from "../hooks/useFetch";
import classes from "../styles/Sumarry.module.css";


export default function Summary({ score, noq }) {
  // calculate result based on the score
  const result = "good";

  // fetch gif based on the result
  const { loading, error, gif } = useFetch(
    `https://api.giphy.com/v1/gifs/search?api_key=2nZjnQOqAccdgUoNZZlKw4K7HMktJGQ9&q=${result}&limit=1&offset=0&rating=r&lang=en`
  );

  return (
    <>
      <div className={classes.summary}>
        <div className={classes.point}>
          <p className={classes.score}>
            Your score is <br /> {score} out of {noq * 5}
          </p>
        </div>

        {loading && <div className={classes.badge}>Loading your badge...</div>}

        {error && <div className={classes.badge}>An error occured!</div>}

        {!loading && !error && (
          <div className={classes.badge}>
            <img alt="Success" />
          </div>
        )}
      </div>
    </>
  );
}
